var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-bag"},[_c('IconCart',{staticClass:"empty-bag-icon"}),_c('div',{staticClass:"empty-bag-message"},[_vm._v(" Select an item to start your order ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }